import React from 'react';

import * as styles from './index.module.scss';

export const Spinner: React.FC = () => <div className={styles.spinner} />;
